/* eslint-disable react/prop-types */
/* eslint-disable no-underscore-dangle */
import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  InputAdornment,
  Button,
} from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import PersonIcon from '@mui/icons-material/Person';
import dayjs from 'dayjs';

// import Button from 'components/Button';

export function CustomerForm({
  errors,
  customerType,
  customer,
  Controller,
  control,
}) {
  const addressParts = customer?.address ? customer.address.split(',') : [];
  return (
    <div className="flex flex-wrap">
      <div className="w-full px-1 py-2 font-semibold">
        เพิ่มรายละเอียดลูกค้า
      </div>
      <div className="w-1/2 px-1 py-2">
        <Controller
          name={'name'}
          control={control}
          defaultValue={customer ? customer?.name : ''}
          render={({ field }) => (
            <TextField
              {...field}
              label="ชื่อ"
              fullWidth
              size={'small'}
              helperText={errors.firstname && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-1/2 px-1 py-2">
        <Controller
          name={'born'}
          control={control}
          defaultValue={
            customer ? dayjs(customer?.born).format('YYYY-MM-DD') : ''
          }
          render={({ field }) => (
            <TextField
              {...field}
              label="วันเกิด"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
              size={'small'}
              helperText={errors.born && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-1/2 px-1 py-2">
        <Controller
          name={'cardID'}
          control={control}
          defaultValue={customer ? customer?.cardId : ''}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              label="เลขบัตรประจำตัวประชาชน"
              variant="outlined"
              placeholder="เลขบัตรประจำตัวประชาชน"
              type="tel"
              // InputProps={{
              //   startAdornment: (
              //     <InputAdornment position="start"></InputAdornment>
              //   ),
              //   inputMode: 'numeric',
              // }}
              inputProps={{
                maxLength: 13,
                minLength: 13,
              }}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, '');
              }}
            />
          )}
        />
      </div>
      <div className="w-1/2 px-1 py-2">
        <Controller
          name={'tel'}
          control={control}
          defaultValue={customer ? customer?.tel : ''}
          render={({ field }) => (
            <TextField
              {...field}
              label="เบอร์โทรศัพท์"
              fullWidth
              size={'small'}
              helperText={errors.lastname && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-1/2 px-1 py-2">
        <Controller
          name={'tax.taxnumber'}
          control={control}
          defaultValue={customer ? customer?.tax?.taxnumber : ''}
          render={({ field }) => (
            <TextField
              {...field}
              label="เลขประจำตัวผู้เสียภาษี"
              fullWidth
              size={'small'}
              helperText={errors.tax?.taxnumber && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>

      <div className="w-full">
        <h1>ข้อมูลที่อยู่</h1>
      </div>

      <div className="w-1/2 px-1 py-2">
        <Controller
          name={'address.no'}
          control={control}
          defaultValue={addressParts[0] || ''}
          render={({ field }) => (
            <TextField
              {...field}
              label="เลขที่"
              fullWidth
              size={'small'}
              helperText={errors.address?.no && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-1/2 px-1 py-2">
        <Controller
          name={'address.moo'}
          control={control}
          defaultValue={addressParts[1] || ''}
          render={({ field }) => (
            <TextField
              {...field}
              label="หมู่ที่"
              fullWidth
              size={'small'}
              helperText={errors.address?.moo && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-1/2 px-1 py-2">
        <Controller
          name={'address.road'}
          control={control}
          defaultValue={addressParts[2] || ''}
          render={({ field }) => (
            <TextField
              {...field}
              label="ถนน"
              fullWidth
              size={'small'}
              helperText={errors.address?.road && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-1/2 px-1 py-2">
        <Controller
          name={'address.subdistrict'}
          control={control}
          defaultValue={addressParts[3] || ''}
          render={({ field }) => (
            <TextField
              {...field}
              label="แขวง/ตำบล"
              fullWidth
              size={'small'}
              helperText={errors.address?.subdistrict && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-1/2 px-1 py-2">
        <Controller
          name={'address.district'}
          control={control}
          defaultValue={addressParts[4] || ''}
          render={({ field }) => (
            <TextField
              {...field}
              label="เขต/อำเภอ"
              fullWidth
              size={'small'}
              helperText={errors.address?.district && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-1/2 px-1 py-2">
        <Controller
          name={'address.province'}
          control={control}
          defaultValue={addressParts[5] || ''}
          render={({ field }) => (
            <TextField
              {...field}
              label="จังหวัด"
              fullWidth
              size={'small'}
              helperText={errors.address?.province && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-1/2 px-1 py-2">
        <Controller
          name={'address.country'}
          control={control}
          defaultValue={addressParts[6] || ''}
          render={({ field }) => (
            <TextField
              {...field}
              label="ประเทศ"
              fullWidth
              size={'small'}
              helperText={errors.address?.country && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-1/2 px-1 py-2">
        <Controller
          name={'address.postalCode'}
          control={control}
          defaultValue={addressParts[7] || ''}
          render={({ field }) => (
            <TextField
              {...field}
              label="รหัสไปรษณีย์"
              fullWidth
              size={'small'}
              helperText={errors.address?.postalCode && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-full">
        <h1>ข้อมูลติดต่อและอาชีพ</h1>
      </div>
      <div className="w-1/2 px-1 py-2">
        <Controller
          name={'social.line'}
          control={control}
          defaultValue={customer ? customer?.social?.line : ''}
          render={({ field }) => (
            <TextField
              {...field}
              label="ไลน์"
              fullWidth
              size={'small'}
              helperText={errors.social?.line && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-1/2 px-1 py-2">
        <Controller
          name={'social.facebook'}
          control={control}
          defaultValue={customer ? customer?.social?.facebook : ''}
          render={({ field }) => (
            <TextField
              {...field}
              label="เฟสบุ๊ค"
              fullWidth
              size={'small'}
              helperText={errors.social?.facebook && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-1/2 px-1 py-2">
        <Controller
          name={'social.email'}
          control={control}
          defaultValue={customer ? customer?.social?.email : ''}
          render={({ field }) => (
            <TextField
              {...field}
              label="อีเมล"
              fullWidth
              size={'small'}
              helperText={errors.social?.email && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-1/2 px-1 py-2">
        <Controller
          name={'job'}
          control={control}
          defaultValue={customer ? customer?.job : ''}
          render={({ field }) => (
            <TextField
              {...field}
              label="อาชีพ"
              fullWidth
              size={'small'}
              helperText={errors?.job && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="text-center">
        <Button size="medium " onClick={() => {}}></Button>
      </div>
    </div>
  );
}

CustomerForm.propTypes = {
  location: PropTypes.object,
  errors: PropTypes.shape({
    name: PropTypes.object,
    born: PropTypes.object,
    tel: PropTypes.object,
    address: PropTypes.object,
    taxnumber: PropTypes.object,
  }),
  customer: PropTypes.object,
  Controller: PropTypes.func,
  control: PropTypes.object,
};

CustomerForm.defaultProps = {
  customer: null,
};

export default CustomerForm;
